import {
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";

import { authRoutes } from "./authRoutes";
import { routes } from "./routes";
import { sharedRoutes } from "./sharedRoutes";

const routesList = createRoutesFromElements([
  routes,
  authRoutes,
  ...sharedRoutes,
]);

export const router: ReturnType<typeof createBrowserRouter> =
  createBrowserRouter(routesList);
